define( 
	'app/ui/filter/filter',[
		'jquery'
	],

	function ( $ ) {

		var Filter;
		var $filters;
		var $filterWrappers;
		var $filterInfo;
		var $filterAjax;
		var ajaxId = "filter";
		var ajaxUrl;
		var historySupport = !!(window.history && window.history.pushState);
		var initialState;
		var warning = $('<p class="warning">There was an error, please try again</p>');
		var $loadMore;

		return {

			/** Initialise the Filter functionality. 
			*
			* @method module:app/ui/filter/filter.init
			*/
			init: function () {
				Filter = this;
				$filterInfo = $( '.js-filter-info' );
				$filterWrappers = $filterInfo.find( '.js-filter' );
				$filters = $filterWrappers.find('select');
				$filterAjax = $('.js-filter-ajax');
				ajaxUrl = $filterAjax.data('ajax-url');
				$loadMore = $filterAjax.find('.js-load-more');

				var initialSelections = Filter._getSelections();
				//Filter._setSelections(initialSelections);
				initialState = {
					html: $filterAjax.html(),
					selections: initialSelections
				};


				this._initEvents();
			},

			_initEvents: function () {
				$filters.on('change', Filter._processChange);
				$filterAjax.on('click', '.pagination a', Filter._processPagination);
				//$.subscribe('/ajax/ready/'+ajaxId, Filter._processAjaxResponse);
				$(window).on('popstate', Filter._processHistoryPopstate);
				$filterAjax.on('click', '.js-load-more', Filter._processLoadMore);
			},

			_processChange: function ( event ) {
				var $thisFilter = $( this );
				$thisFilter.siblings('.js-filter-text').text($thisFilter.find('option:selected').text());

				var querys = Filter._getSelections();

				var str = "?";
				for (var key in querys) {
					if(querys[key] !== "All"){
						if (str != "?") {
							str += "&";
						}
						str += key + "=" + querys[key];
					}
				}

				Filter._getAjax(str, querys, true, false);
			},

			_getSelections: function () {
				var querys = {};
				$filters.each(function(){
					var $tempFilter = $(this);
					querys[$tempFilter.data('category')] = $tempFilter.val();
				});
				return querys;
			},

			_setSelections: function (selections) {
				for (var key in selections) {
					var $thisFilter = $filters.filter('[data-category="'+key+'"]');
					$thisFilter.val(selections[key]);
					$thisFilter.siblings('.js-filter-text').text($thisFilter.find('option:selected').text());
				}
			},

			_processPagination: function (event) {
				event.preventDefault();
				Filter._getAjax($(this).attr('href')/*$(this).data('url')*/, Filter._getSelections(), true,false);
			},

			_processLoadMore:function(event){
				event.preventDefault();
				Filter._getAjax($(this).attr('href'), Filter._getSelections(), false, true);
			},

			_getAjax: function (url, selections, addHistory, isLoadMore ) {
				var tempUrl = url.indexOf('?')===0 ? ajaxUrl + url : ajaxUrl;
				$filterAjax.addClass('loading');
				$.ajax( {
					url: tempUrl,
					success: function(data){
						Filter._processAjaxResponse(data, url, selections, addHistory, isLoadMore);
					},
					error: function(data){
						$filterAjax.prepend(warning);
						$filterAjax.removeClass('loading');
					}
				} );
			},

			_processAjaxResponse: function (data, url, selections, addHistory, isLoadMore) {
				if (isLoadMore) {
					Filter._processLoadMoreHtml(data);
					$filterAjax.removeClass('loading');
				} else {
					Filter._processHtml(data);
					$filterAjax.removeClass('loading');
					if (historySupport && addHistory) {
						var stateData = {
							html: data,
							selections: selections
						};
						history.pushState(stateData, '', url);
					}
				}
			},

			_processHistoryPopstate: function(event) {
				var currentState = event.originalEvent.state || initialState;
				Filter._processHtml(currentState.html);
				Filter._setSelections(currentState.selections);
				setTimeout(function(){$('html, body').scrollTop($filterInfo.offset().top);},20);
			},

			_processHtml: function (html) {
				$filterAjax.html(html);
				setTimeout(function () {
					$.publish('/lazyload/ajax', { html: $filterAjax });
					$.publish('/ajax/replace/loaded', { html: $filterAjax });
					var offTop = $filterAjax.offset().top,
					winTop = window.scrollY || window.pageYOffset;
					if (winTop > offTop) {
						$("html, body").animate({ scrollTop: offTop }, 300);
					}
				}, 10);
			},

			_processLoadMoreHtml: function (html) {
				if($filterAjax.find('.js-pagination-wrapper').length) {
					$filterAjax.find('.js-pagination-wrapper').remove();
				}
				$filterAjax.append(html);
				setTimeout(function () {
					$.publish('/lazyload/ajax', { html: $filterAjax });
					$.publish('/ajax/replace/loaded', { html: $filterAjax });
					var offTop = $('.js-filter-ajax ol:last-of-type').offset().top;
					$("html, body").animate({ scrollTop: offTop }, 300);
				},10);
			}

		};

	}
);
